<button mat-icon-button [matMenuTriggerFor]="menu" class="mat-icon-button">
  <mat-icon>filter_list</mat-icon>
</button>
<mat-menu #menu="matMenu">
  @for (category of resultPercentage; track category) {
    <div class="category-container d-flex align-items-center mx-2">
      <button
        (click)="changeCategory(category.difficulty)"
        [ngClass]="getCategoryCssClass(category.difficulty)"
        mat-menu-item
        class="btn-category category-chip mx-auto"
      >
        {{ category.name }}
      </button>
      <div class="check-icon-container">
        @if (category.difficulty === selectedCategory) {
          <img src="../../../assets/images/icon/check.svg" class="check-icon" />
        }
      </div>
    </div>
  }
</mat-menu>
<div class="chart-card">
  <div class="chart-container">
    <div class="chart-custom-size">
      <ngx-charts-pie-chart
        [scheme]="colorScheme"
        [results]="filteredAndTransformedData"
        [labels]="false"
        [doughnut]="true"
        [arcWidth]="0.6"
        [tooltipDisabled]="true"
        [view]="view"
      >
      </ngx-charts-pie-chart>
    </div>
    <div class="chart-info">
      @for (item of getFilteredItems(selectedCategory); track item) {
        <div>
          <div
            class="text-center category-chip-display"
            [ngClass]="getCategoryCssInfoClass(selectedCategory)"
          >
            {{ item.name }}
          </div>
        </div>
      }
      <div class="chart-percentage">{{ selectedCategoryPercentage() }}%</div>
    </div>
  </div>
  <p class="chart-text">{{ chartTitle }}</p>
</div>
